// extracted by mini-css-extract-plugin
export default {"content":"ELRaj6jDgL50rhY2Yc1s","text":"bPD_qPZxWz2XWJ1YuQ0b","address":"fb3yIOg9mETlSuxCrRT6"};